import api from '@/api/index.js'

const season_ticket_revisions = {
  state: {
    loading: false,
    updating: false,
    data: null,
    single: null, // Represents single retrieved team
    created: null,
    error: null,
    placeOfPurchaseOptions: ["online", "service_desk"],
    additionalDataOptions: ["personal_data", "contacts", "assignee", "document"],
  },

  mutations: {
    SET_SEASON_TICKET_REVISIONS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_SEASON_TICKET_REVISIONS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_SEASON_TICKET_REVISIONS: (state, data) => {
      state.data = data
      state.loading = false;
    },
    SET_SEASON_TICKET_REVISION: (state, data) => {
      state.single = data
      state.loading = false;
    },
    SET_SEASON_TICKET_REVISIONS_ERROR: (state, error) => {
      state.error = error
    },
    SET_SEASON_TICKET_CREATED: (state, created) => {
      state.created = created
    }
  },

  actions: {
    GetSeasonTicketRevision({commit}, payload) {
      commit('SET_SEASON_TICKET_REVISION', null)
      commit('SET_SEASON_TICKET_REVISIONS_ERROR', null)
      commit('SET_SEASON_TICKET_REVISIONS_LOADING', true)
      return api.get(`season-tickets/${payload.seasonTicketId}/revisions/${payload.id}`)
        .then((response) => {
          commit('SET_SEASON_TICKET_REVISION', response)
        })
        .catch((error) => {
          commit('SET_SEASON_TICKET_REVISIONS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_SEASON_TICKET_REVISIONS_LOADING', false)
        })
    },
    CreateSeasonTicketRevision({commit}, payload) {
      commit('SET_SEASON_TICKET_REVISIONS_UPDATING', true);
      commit('SET_SEASON_TICKET_REVISIONS_ERROR', null)
      commit('SET_SEASON_TICKET_CREATED', null)
      return api.post(`season-tickets/${payload.seasonTicketId}/revisions`, payload.data)
        .then((response) => {
          commit('SET_SEASON_TICKET_CREATED', response.body)
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SEASON_TICKET_REVISIONS_ERROR', error)
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false);
        })
    },
    UpdateSeasonTicketRevision({commit}, payload) {
      commit('SET_SEASON_TICKET_REVISIONS_ERROR', null)
      commit('SET_ERROR', null)
      commit('SET_SEASON_TICKET_REVISIONS_UPDATING', true)
      return api.put(`season-tickets/${payload.seasonTicketId}/revisions/${payload.id}`, payload.data)
        .then((response) => {
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false)
          commit('SET_SEASON_TICKET_REVISION', response.body)
        })
        .catch((error) => {
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false)
          commit('SET_SEASON_TICKET_REVISIONS_ERROR', error)
          if (!payload.formSubmit) {
            commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          }
        })
    },
    DeleteSeasonTicketRevision({commit}, payload) {
      commit('SET_ERROR', null)
      commit('SET_SEASON_TICKET_REVISIONS_UPDATING', true);
      commit('SET_SEASON_TICKET_REVISIONS_ERROR', null)
      return api.delete(`season-tickets/${payload.seasonTicketId}/revisions/${payload.id}`)
        .then((response) => {
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_SEASON_TICKET_REVISIONS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_SEASON_TICKET_REVISIONS_UPDATING', false);
        })
    }
  }
}

export default season_ticket_revisions
